import { ApiService } from "../../../config";
import { registerUser } from "@/config/socket";
import { TAnalysisRequestRes, TProcessCountRes } from "../models";
import { handleError } from "@/utils/parseApiReturn";

const getTermsConditions = async (): Promise<any> => {
  try {
    const result = await ApiService.get(`/users/terms-conditions`);
    if (result) {
      return result.data;
    }
  } catch (error) {
    console.error(error);
  }
};

const setTermsConditions = async (): Promise<any> => {
  try {
    const result = await ApiService.post("/users/terms-conditions");
    if (result) {
      return result.data;
    }
  } catch (error) {
    console.error(error);
  }
};

const analyze = async (
  cpf: string,
  accountId: number,
  userId: number
): Promise<TAnalysisRequestRes> => {
  const cleanedCPF = cpf.replace(/[^a-zA-Z0-9 ]/g, "");

  try {
    const response = await ApiService.post(`/processes/analyze`, {
      cpf: cleanedCPF,
      accountId,
      userId
    });

    registerUser({ accountId: accountId.toString(), cpf });
    return response.data;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para realizar a análise:");
  }
};
const getProcessCount = async (
  accountId: number
): Promise<TProcessCountRes> => {
  try {
    const response = await ApiService.get(
      `/processes/accounts/${accountId}/count-processes`
    );
    return response.data;
  } catch (error) {
    return handleError(
      error,
      "Erro na requisição para obter o contador de processos"
    );
  }
};
export const HomeService = {
  getTermsConditions,
  setTermsConditions,
  analyze,
  getProcessCount
};
